const ORDER_STATUS = {
  INIT_TRANS: 'INIT_TRANS',
  PAY_ACQUIRED: 'PAY_ACQUIRED',
  DELIVERY_ORDER_CREATED: 'DELIVERY_ORDER_ACTIVATED',
  REQUEST_FOR_PICKUP: 'REQUEST_FOR_PICKUP',
  SEARCH_FOR_DRIVER: 'SEARCH_FOR_DRIVER',
  DRIVER_ENROUTE: 'DRIVER_ENROUTE',
  CANCELLED_BY_USER: 'CANCELLED_BY_USER',
  CANCELLED_BY_SYSTEM: 'CANCELLED_BY_SYSTEM',
  CANCELLED_BY_PARTNER: 'CANCELLED_BY_PARTNER',
  PICKUP_REJECTED: 'PICKUP_REJECTED',
  PICKUP_CANCELLED: 'PICKUP_CANCELLED',
  PACKAGE_PICKED_UP: 'PACKAGE_PICKED_UP',
  PACKAGE_IN_DELIVERY: 'PACKAGE_IN_DELIVERY',
  PACKAGE_ARRIVED: 'PACKAGE_ARRIVED',
  DELIVERY_ORDER_RETURNED: 'DELIVERY_ORDER_RETURNED',
  CANCEL_FAILED: 'CANCEL_FAILED',
  CANCEL_SUCCESS: 'CANCEL_SUCCESS',
  PACKAGE_IN_TRANSIT: 'PACKAGE_IN_TRANSIT',
  PACKAGE_IN_RETURN: 'PACKAGE_IN_RETURN',
  ORDER_EXPIRED: 'ORDER_EXPIRED',
};

const ETA_UNIT = {
  HOURS: 'HOURS',
  DAYS: 'DAYS',
};

export { ORDER_STATUS, ETA_UNIT };
